import type { DraftLength, DraftTone } from "./draftMessageService";
import "./AiDraftMessage.scss";

export const TONE_OPTIONS: { value: DraftTone; messageId: string }[] = [
  { value: "casual", messageId: "app.toolboxChat.draftMessage.tone.casual" },
  { value: "professional", messageId: "app.toolboxChat.draftMessage.tone.professional" },
];

export const LENGTH_OPTIONS: { value: DraftLength; messageId: string }[] = [
  { value: "brief", messageId: "app.toolboxChat.draftMessage.length.brief" },
  { value: "standard", messageId: "app.toolboxChat.draftMessage.length.standard" },
  { value: "detailed", messageId: "app.toolboxChat.draftMessage.length.detailed" },
];

export function PillGroup<T extends string>({
  options,
  selected,
  name,
  labelId,
  onSelect,
}: {
  options: { value: T; label: string }[];
  selected: T;
  name: string;
  labelId: string;
  onSelect: (value: T) => void;
}) {
  return (
    <div className="draft-pill-group" role="radiogroup" aria-labelledby={labelId}>
      {options.map(({ value, label }) => (
        <label
          key={value}
          htmlFor={`${name}-${value}`}
          className={`draft-pill${selected === value ? " draft-pill--selected" : ""}`}
        >
          <input
            type="radio"
            id={`${name}-${value}`}
            name={name}
            value={value}
            checked={selected === value}
            onChange={() => onSelect(value)}
            className="draft-pill-input"
          />
          <span className="draft-pill-radio" aria-hidden="true">
            <span className="draft-pill-radio-dot" />
          </span>
          {label}
        </label>
      ))}
    </div>
  );
}
